export const BASE_URL = `https://${window.location.host}/api/subscriber`;
export const API_BASE_URL = `https://${window.location.host}/api`;

export const SUCCESS = "success";
export const ERROR = "danger";
export const INFO = "info";

export const LOGIN = "/login";
export const REGISTER = "/register";
export const FORGOT_PASSWORD = "/forgot-password";
export const DASHBOARD = "/dashboard";
export const FAVOURITE = "/favourite";
export const REPORTED_ISSUE = "/reported-issues";
export const MANAGE_SUBSCRIPTION = "/manage-subscription";
export const RECALL_DETAILS = "/recall-details/:type/:id";
export const REPORTED_ISSUE_DETAILS = "/reported-issues/details/:type/:recallId/:id";
export const EDIT_PROFILE = "/edit-profile";
export const NOTIFICATION_PREFERANCES = "/notification-preferances";
export const CONFIRM_ACCOUNT = "/confirm-account/:token";
export const RESET_PASSWORD = "/reset-password/:token";
export const SEARCH = "/search";
export const CHANGE_PASSWORD = "/change-password";
export const SECURITY_SETTINGS = "/security-settings";

export const AUTO = "auto";
export const FOOD = "food";
export const PRESS = "press";
export const MEDICINE = "medicine";
export const CHILD = "child";
export const CP = "consumer";
export const PET = "pet";

// Dashboard Tab Routes
export const TAB_ROUTES = {
  [AUTO]: "auto-dashboard",
  [FOOD]: "food-dashboard",
  [MEDICINE]: "drug-dashboard",
  [CHILD]: "child-dashboard",
  [CP]: "cp-dashboard",
  [PRESS]: "press-dashboard",
  [PET]: "pet-recall/list"
};

export const CATEGORY_ID_MAP = {
  [AUTO]: 1,
  [FOOD]: 2,
  [MEDICINE]: 3,
  [CHILD]: 4,
  [CP]: 5,
  [PRESS]: 6,
  [PET]: 7
};

export const CATEGORY_COMPLETE_NAME_MAP = {
  [AUTO]: "Automobile",
  [FOOD]: "Food",
  [MEDICINE]: "Medicine",
  [CHILD]: "Children",
  [CP]: "Consumer Product",
  [PRESS]: "Press Release",
  [PET]: "Pet"
};

export const CATEGORIES_ID_NAME_MAP = [
  { id: CATEGORY_ID_MAP[AUTO], name: CATEGORY_COMPLETE_NAME_MAP[AUTO] },
  { id: CATEGORY_ID_MAP[FOOD], name: CATEGORY_COMPLETE_NAME_MAP[FOOD] },
  { id: CATEGORY_ID_MAP[MEDICINE], name: CATEGORY_COMPLETE_NAME_MAP[MEDICINE] },
  { id: CATEGORY_ID_MAP[CHILD], name: CATEGORY_COMPLETE_NAME_MAP[CHILD] },
  { id: CATEGORY_ID_MAP[CP], name: CATEGORY_COMPLETE_NAME_MAP[CP] },
  { id: CATEGORY_ID_MAP[PRESS], name: CATEGORY_COMPLETE_NAME_MAP[PRESS] },
  { id: CATEGORY_ID_MAP[PET], name: CATEGORY_COMPLETE_NAME_MAP[PET] }
];

export const CATEGORY_NAME_MAP = {
  1: AUTO,
  2: FOOD,
  3: MEDICINE,
  4: CHILD,
  5: CP,
  6: PRESS,
  7: PET
};

export const ROUTES = {
  LOGIN,
  REGISTER,
  FORGOT_PASSWORD,
  DASHBOARD,
  FAVOURITE,
  MANAGE_SUBSCRIPTION,
  REPORTED_ISSUE,
  RECALL_DETAILS,
  REPORTED_ISSUE_DETAILS,
  EDIT_PROFILE,
  NOTIFICATION_PREFERANCES,
  CONFIRM_ACCOUNT,
  RESET_PASSWORD,
  SEARCH,
  CHANGE_PASSWORD,
  SECURITY_SETTINGS
};
